import React from 'react'
import MUIDataTable from "mui-datatables";
import { createTheme, ThemeProvider } from '@mui/material/styles';

import { Breadcrumbs, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import {SENSOR_COLUMN_OPTIONS, COLOR} from '../../constants'
import MultipleLineGraph from '../../components/MultipleLineGraph';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Summary from '../UserDetails/Summary';

function  SensorData(){
  let params = useParams();
  const { status, data, compliance, notes, intakeCheckList } = useSelector((state) => state.user);

  const getMuiTheme = () => createTheme({
    components: {
      MuiPaper:{
        styleOverrides:{
          root:{
            boxShadow:'none',
            fontFamily: 'Open Sans'
          }
        }
      },
      MuiTable:{
        styleOverrides:{
          root:{
            borderCollapse:'separate',
            borderSpacing:1.5
          }
        }
        
      },
      MuiTableHead:{
        styleOverrides:{
          root: {
            backgroundColor:'#def1fc',
             textAlign:'center',
              padding:'0px',
              width:'10%',
          }
        }
      },
      MuiTableCell:{
        styleOverrides:{
          root: {
            textAlign:'center',
            padding:'0px',
            fontFamily:'Open Sans'
          }
        }
      },
       MuiTableBody: {
        styleOverrides:{
          root: {
              backgroundColor: "#f8f8f8",
             
         }
        }
      }, 
     
    }
  })

  // render() {


    const columns = [
      {
        name: "",
        options: {
          filter: true,
          setCellProps: () => ({
            style: {
              textAlign:'left',
              whiteSpace: "nowrap",
              position: "sticky",
              left: "0",
              background: "#FFF",
              zIndex: 100,
              border:1,
              padding:'0px 10px',
             width:'20px'
         
            }
          }),
          setCellHeaderProps: () => ({
            style: {
              textAlign:'left',
              whiteSpace: "nowrap",
              position: "sticky",
              left: 0,
              border:1,
              background:'#def1fc',  
              zIndex: 101,
              padding:'0px 10px',
              width:'20px'
            }
          })
        }
      },
      {
        name: "1/1/2023",
        options: SENSOR_COLUMN_OPTIONS
      },
      {
        name: "2/1/2023",
        options: SENSOR_COLUMN_OPTIONS
      },
      {
        name: "3/1/2023",
        options: SENSOR_COLUMN_OPTIONS
      },
      {
        name: "4/1/2023",
        options: SENSOR_COLUMN_OPTIONS
      },
      {
        name: "5/1/2023",
        options: SENSOR_COLUMN_OPTIONS
      },
      {
        name: "6/1/2023",
        options: SENSOR_COLUMN_OPTIONS
      },
      {
        name: "7/1/2023",
        options: SENSOR_COLUMN_OPTIONS
      },
      {
        name: "8/1/2023",
        options: SENSOR_COLUMN_OPTIONS
      },
      {
        name: "9/1/2023",
        options:SENSOR_COLUMN_OPTIONS
      },
      {
        name: "10/1/2023",
        options: SENSOR_COLUMN_OPTIONS
      },
      {
        name: "11/1/2023",
        options: SENSOR_COLUMN_OPTIONS
      },
      {
        name: "12/1/2023",
        options: SENSOR_COLUMN_OPTIONS
      },
      {
        name: "13/1/2023",
        options:SENSOR_COLUMN_OPTIONS
      }
      ,
      {
        name: "14/1/2023",
        options: SENSOR_COLUMN_OPTIONS
      }
      ,
      {
        name: "15/1/2023",
        options: SENSOR_COLUMN_OPTIONS
      },
      {
        name: "16/1/2023",
        options: SENSOR_COLUMN_OPTIONS
      },
      {
        name: "17/1/2023",
        options: SENSOR_COLUMN_OPTIONS
      },
      {
        name: "18/1/2023",
        options: SENSOR_COLUMN_OPTIONS
      },
      {
        name: "19/1/2023",
        options: SENSOR_COLUMN_OPTIONS
      },
      {
        name: "20/1/2023",
        options: SENSOR_COLUMN_OPTIONS
      },
      {
        name: "21/1/2023",
        options: SENSOR_COLUMN_OPTIONS
      },
      {
        name: "22/1/2023",
        options: SENSOR_COLUMN_OPTIONS
      },
      {
        name: "23/1/2023",
        options: SENSOR_COLUMN_OPTIONS
      },
      {
        name: "24/1/2023",
        options:SENSOR_COLUMN_OPTIONS
      },
      {
        name: "25/1/2023",
        options: SENSOR_COLUMN_OPTIONS
      },
      {
        name: "26/1/2023",
        options: SENSOR_COLUMN_OPTIONS
      },
      {
        name: "27/1/2023",
        options: SENSOR_COLUMN_OPTIONS
      },
      {
        name: "28/1/2023",
        options:SENSOR_COLUMN_OPTIONS
      }
      ,
      {
        name: "29/1/2023",
        options: SENSOR_COLUMN_OPTIONS
      }
      ,
      {
        name: "30/1/2023",
        options: SENSOR_COLUMN_OPTIONS
      },
      {
        name: "1/2/2023",
        options: SENSOR_COLUMN_OPTIONS
      },
      {
        name: "2/2/2023",
        options: SENSOR_COLUMN_OPTIONS
      },
      {
        name: "3/2/2023",
        options: SENSOR_COLUMN_OPTIONS
      },
      {
        name: "4/2/2023",
        options:SENSOR_COLUMN_OPTIONS
      }
      ,
      {
        name: "5/2/2023",
        options: SENSOR_COLUMN_OPTIONS
      }
      ,
      {
        name: "6/2/2023",
        options: SENSOR_COLUMN_OPTIONS
      }

    ];

    const data1 = [
      [
        "MVC Score",
        3,
        12,
        30,
        22,
        10,
        4,
        5,
        3,
        4,
        5,
        12,
        22,
        10,
        11,
        15,
        3,
        121,
        30,
        22,
        101,
        4,
        5,
        3,
        4,
        5,
        12,
        22,
        10,
        113,
        15,
        5,
        126,
        22,
        10,
        11,
        15
      ],
      [
        "STS (Number of Sit to Stands)",
        3,
        12,
        30,
        22,
        10,
        4,
        5,
        3,
        4,
        5,
        12,
        22,
        10,
        11,
        15,
        3,
        12,
        30,
        22,
        10,
        4,
        5,
        3,
        4,
        5,
        12,
        22,
        10,
        11,
        15,
        5,
        12,
        22,
        10,
        11,
        15
      ],
      [
        "TUG Time(sec)",
        3,
        12,
        30,
        22,
        10,
        4,
        5,
        3,
        4,
        5,
        12,
        22,
        10,
        11,
        15,
        3,
        12,
        30,
        22,
        10,
        4,
        5,
        3,
        4,
        5,
        12,
        22,
        10,
        11,
        15,
        5,
        12,
        22,
        10,
        11,
        15
      ],
      
    ];

    const options = {
      filter: false,
      filterType: "dropdown",
      responsive: "standard",
      resizableColumns: false,
      sort: false,
      pagination:false,
      download: false,
        print: false,
        viewColumns: false,
        searchOpen: false,
        search: false,
      fixedHeader: false,
      fixedSelectColumn: false,
      tableBodyHeight: "200px",
      selectableRows: 'none',
      // borderBottom:'none'
    };

    return (
      <div>

        <div className='full-container'>
          <div style={{margin:'0px 10px'}}>
            <Breadcrumbs aria-label="breadcrumb">
              <Link underline="hover" color="inherit" to="/users" >
                Users
              </Link>
             
                 <Link
                            underline="hover"
                            color="inherit"
                            to={`/user_details/${params.userId}`}
                        >
                Summary
              </Link>
              <Typography  color="text.primary">Performance Details</Typography>
            </Breadcrumbs>
            {data &&<div style={{backgroundColor: "aliceblue",padding:"10px",borderRadius:'10px'}}> <Summary data={data} compliance={compliance} /></div>}

          </div>
        
          <div style={{padding:'0px 10px'}}>
            <div style={{border:'1px solid #ccc', marginTop:'20px'}}>
              <ThemeProvider theme={getMuiTheme()}>
                  <MUIDataTable
                    title={""}
                    data={data1}
                    columns={columns}
                    options={options}
                    border={1}
                  />
              </ThemeProvider>
            </div>
          </div>
          {/* Code for LineChart start */}
          <div style={{padding:'0px 10px'}}>  
            <div style={{border:'1px solid #ccc', marginTop:'20px' }}>
              <div style={{backgroundColor:'#fff', marginTop:10, display:'flex', justifyContent:'space-between'}}>
                <div style={{display:'flex'}}>
                  <div style={{display:'flex', marginLeft:20}}>
                    <div style={{textAlign:'center'}}>
                      <div  style={{color:'#003163', fontWeight:'bold',margin:'0px 5px', fontSize:'14px'}}>
                        MVC Score
                      </div>
                      <div style={{color:'#003163', fontWeight:'bold',margin:'0px 5px', fontSize:'20px'}}>
                        {62}
                      </div>
                    </div>
                    <div style={{ fontFamily: 'Open Sans',
                                  width:'30%',
                                  marginLeft:5,
                                  color:`${true ? COLOR.PERCENTAGE_IN_GREEN : COLOR.PERCENTAGE_IN_RED}`,
                                  fontWeight:800, 
                                  fontSize:12}}> 
                        +{20}% 
                        <div style={{fontSize:'7px',fontStyle:'italic', textWrap:'nowrap', fontWeight:'bold', marginLeft:'1px'}} >
                          ({'captionText'})
                        </div>
                    </div>
                  </div>
                  <div style={{display:'flex', marginLeft:20}}>
                    <div style={{textAlign:'center'}}>
                      <div  style={{color:'#003163', fontWeight:'bold',margin:'0px 5px', fontSize:'14px'}}>
                        STS Score
                      </div>
                      <div style={{color:'#003163', fontWeight:'bold',margin:'0px 5px', fontSize:'20px'}}>
                        {48}
                      </div>
                    </div>
                    <div style={{ fontFamily: 'Open Sans',
                                  width:'30%',
                                  marginLeft:5,
                                  color:`${true ? COLOR.PERCENTAGE_IN_GREEN : COLOR.PERCENTAGE_IN_RED}`,
                                  fontWeight:800, 
                                  fontSize:12}}> 
                        +{20}% 
                        <div style={{fontSize:'7px',fontStyle:'italic', textWrap:'nowrap', fontWeight:'bold', marginLeft:'1px'}} >
                          ({'captionText'})
                        </div>
                    </div>
                  </div>
                  <div style={{display:'flex', marginLeft:20}}>
                    <div style={{textAlign:'center'}}>
                      <div  style={{color:'#003163', fontWeight:'bold',margin:'0px 5px', fontSize:'14px'}}>
                        TUG Score
                      </div>
                      <div style={{color:'#003163', fontWeight:'bold',margin:'0px 5px', fontSize:'20px'}}>
                        {37}
                      </div>
                    </div>
                    <div style={{ fontFamily: 'Open Sans',
                                  width:'30%',
                                  marginLeft:5,
                                  color:`${true ? COLOR.PERCENTAGE_IN_GREEN : COLOR.PERCENTAGE_IN_RED}`,
                                  fontWeight:800, 
                                  fontSize:12}}> 
                        +{20}% 
                        <div style={{fontSize:'7px',fontStyle:'italic', textWrap:'nowrap', fontWeight:'bold', marginLeft:'1px'}} >
                          ({'captionText'})
                        </div>
                    </div>
                  </div>
                </div>
                <div style={{display:'flex'}}>
                  <div style={{marginRight:20}}><span className='blue100'></span>MVC</div>
                  <div style={{marginRight:20}}><span className='blue200'></span>STS</div>
                  <div style={{marginRight:20}}><span className='blue300'></span>TUG</div>
                </div>
              </div>
              <div>
                <MultipleLineGraph />
              </div>
            </div>
          </div>     
          {/* Code for LineChart end */}
        </div>
      </div>
    );
  // }
}


export default SensorData